import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import Grid from '@mui/material/Grid'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
// import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import dayjs from 'dayjs'
import { urlFromLocationName } from '../_Components/addUrlToLocation'
import { useTranslation } from 'react-i18next'

const StatItem = ({ label, value }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '60px' }}>
    <Typography
      variant='caption'
      sx={{
        color: 'text.secondary',
        fontSize: '0.65rem',
        mb: 0.25
      }}
    >
      {label}
    </Typography>
    <Typography variant='body2' sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
      {value}
    </Typography>
  </Box>
)
export default function Schedule ({ race, distance }) {
  const { t } = useTranslation('raceGuide')
  const distanceData = race?.raceDistances?.find(d => d.distance === distance)
  const schedule = distanceData?.schedule

  // Calculate cutoff in hours using dayjs
  const cutoffHours = schedule?.startTime && schedule?.endTime
    ? dayjs(schedule.endTime).diff(dayjs(schedule.startTime), 'hour')
    : null

  return (
    <Box>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          borderTop: `4px solid ${distanceData?.color}`
        }}
      >
        <CardContent
          sx={{
          m: 0,
          px: 0,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
        >
          {/* Header */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant='subtitle1' sx={{ fontWeight: 600, fontSize: '0.9rem' }}>
              {distanceData?.name}
            </Typography>
            <Chip
              size='small'
              label={`${distanceData?.distance} km`}
              color='icon'
              sx={{ fontWeight: 600, fontSize: '0.8rem', backgroundColor: distanceData?.color, color: distanceData?.color === 'white' ? 'black' : 'white' }}
            />
          </Box>

          <Grid
            container sx={{
            mt: 2
          }}
          >
            <Grid size={{ xs: 12, md: 6 }} sx={{ background: '#222', minHeight: 64, pt: 1 }}>
              <Box sx={{ display: 'flex', width: '100%' }}>
                <Box
                  sx={{
                  display: 'flex',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                  flex: 1,
                  py: 0
                }}
                >
                  <StatItem label={t('schedule.startTime')} value={dayjs(schedule?.startTime).format('DD/MM HH:mm A')} />
                  <StatItem label={t('schedule.endTime')} value={dayjs(schedule?.endTime).format('DD/MM HH:mm A')} />
                  <StatItem label={t('shared.cutoff')} value={t('schedule.cutoffHours', { hours: cutoffHours })} />
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} sx={{ background: '#333' }}>
              <Box sx={{ display: 'flex', width: '100%' }}>
                <Box
                  sx={{
                  display: 'flex',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                  flex: 1,
                  py: 0
                }}
                >
                  <StatItem label={t('shared.ascent')} value={`${distanceData?.ascent}m`} />
                  <StatItem label={t('shared.descent')} value={`${distanceData?.descent}m`} />
                  <StatItem label={t('schedule.netDistance')} value={`${distanceData?.netDistance}m`} />
                  {/* <StatItem label='GPX' value={distance.cutoffTime} /> */}
                  <Button
                    component={Link}
                    color='icon'
                    href={distanceData?.gpx ? `https://d1hi0tbu2kom2c.cloudfront.net/gpx/${race?.slug}/${distanceData?.gpx}` : '#'}
                    download
                    target='_blank'
                    rel='noopener noreferrer'
                    size='small'
                    sx={{
                      p: 0.5,
                      ml: 2,
                      textAlign: 'center',
                      fontSize: '0.75rem',
                      fontWeight: 600,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center'
                    }}
                  >
                    {t('shared.gpx')}
                    <FileDownloadOutlinedIcon />
                  </Button>
                </Box>

                {/* View Map Button - positioned to the right with margin */}
                {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    component={Link}
                    color='icon'
                    href={distanceData.url}
                    target='_blank'
                    rel='noopener noreferrer'
                    size='small'
                    sx={{
                      p: 0.5,
                      ml: 2,
                      textAlign: 'center',
                      fontSize: '0.75rem',
                      fontWeight: 600,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center'
                    }}
                  >
                    View
                    <LocationOnOutlinedIcon />
                  </Button>
                </Box> */}
              </Box>
            </Grid>
            <Grid
              size={6}
              sx={{
                textAlign: 'center',
                py: 1
              }}
            >
              <Typography variant='subtitle1'>
                {t('schedule.startLocation')}
              </Typography>
              {urlFromLocationName(race?.locations, schedule?.startLocationName)}
            </Grid>
            <Grid
              size={6}
              sx={{
                textAlign: 'center',
                py: 1
              }}
            >
              <Typography variant='subtitle1'>
                {t('schedule.finishLocation')}
              </Typography>
              {urlFromLocationName(race?.locations, schedule?.finishLocationName)}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}
